import { RolesModel } from '_/services/models/roles.model';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomDropDownFieldValuesModal from '../CustomDropDownFieldModal';
import { SpaceType } from '_/services/models/enums/space-type.enum';

interface SelectRoleModalProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  roles: RolesModel[];
  selectedRoleId?: string | null;
  onSelect: (roleId: string) => void;
  spaceType: SpaceType;
}

export default function SelectRoleModal({
  visible,
  setVisible,
  roles,
  selectedRoleId,
  onSelect,
  spaceType,
}: SelectRoleModalProps) {
  const { t } = useTranslation();

  return (
    <CustomDropDownFieldValuesModal
      hideDropdown={() => setVisible(false)}
      label={t('workstationScreen.confirmModal.selectRole')}
      setDropdownField={(value) => onSelect(roles.find((role) => role.name === value)?.id || '')}
      value={roles.find((role) => role.id === selectedRoleId)?.name || ''}
      options={roles.map((role) => role.name)}
      visible={visible}
      spaceType={spaceType}
    />
  );
}
